import React from "react";
import { Empty } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartPie, faTimes } from "@fortawesome/free-solid-svg-icons";
import { Pie } from "react-chartjs-2";
import {
  DetailCard,
  DetailCardHeader,
  DetailCardTitleSection,
  DetailCardTitle,
  DetailCardSubtitle,
  DetailCardCloseButton,
  DetailCardCloseIconWrapper,
  ChartContainer,
  EmptyIconWrapper,
  EmptyText,
} from './Styles';
import "../../../theme/Layout/ChartConfig";

interface OrderStatusOverviewProps {
  orderStatuses: {
    completed: number;
    pending: number;
    ready: number;
  };
  onClose: () => void;
  isDarkMode?: boolean;
}

const OrderStatusOverview: React.FC<OrderStatusOverviewProps> = ({
  orderStatuses,
  onClose,
  isDarkMode = false,
}) => {
  const hasOrders = Object.values(orderStatuses).some((count) => count > 0);

  const data = {
    labels: ["Completed", "Pending", "Ready"],
    datasets: [
      {
        data: [
          orderStatuses.completed,
          orderStatuses.pending,
          orderStatuses.ready,
        ],
        backgroundColor: isDarkMode
          ? ["#63B3ED", "#68D391", "#F6AD55"]
          : ["#3182CE", "#38A169", "#ED8936"],
        hoverBackgroundColor: isDarkMode
          ? ["#4299E1", "#48BB78", "#ED8936"]
          : ["#2C5AA0", "#2F855A", "#C05621"],
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: true,
        position: "bottom" as const,
        labels: {
          color: isDarkMode ? "#fff" : "#000",
          usePointStyle: true,
          boxWidth: 10,
          padding: 20,
          font: {
            size: 12,
          },
        },
      },
    },
    maintainAspectRatio: false,
    responsive: true,
  };

  return (
    <DetailCard
      title={
        <DetailCardHeader>
          <DetailCardTitleSection>
            <DetailCardTitle>Order Status Overview</DetailCardTitle>
            <DetailCardSubtitle>Orders mapped by status</DetailCardSubtitle>
          </DetailCardTitleSection>
          <DetailCardCloseButton onClick={onClose}>
            <DetailCardCloseIconWrapper>
              <FontAwesomeIcon icon={faTimes} />
            </DetailCardCloseIconWrapper>
          </DetailCardCloseButton>
        </DetailCardHeader>
      }
    >
      <ChartContainer>
        {hasOrders ? (
          <Pie data={data} options={options} />
        ) : (
          <Empty
            image={
              <EmptyIconWrapper>
                <FontAwesomeIcon icon={faChartPie} />
              </EmptyIconWrapper>
            }
            description={<EmptyText>No orders data found</EmptyText>}
          />
        )}
      </ChartContainer>
    </DetailCard>
  );
};

export default OrderStatusOverview;